<div class="radio-icon-container">
  @if (icon===undefined) {
    <div class="radio-icon"></div>
  }
  @if (icon!==undefined) {
    <div class="radio-custom-icon">
      <cs-icon [name]="icon"></cs-icon>
    </div>
  }
</div>
<div class="radio-content-container">
  <!-- Custom content slot - bypasses cs-label wrapper for full layout control -->
  <ng-content select="[custom-content]"></ng-content>
  <!-- Default content wrapped in cs-label -->
  @if (!hasCustomContent) {
    <div class="radio-label-row">
      <cs-label>
        <ng-content></ng-content>
        @if (recommended) {
          <cs-badge color="gray">{{ LL.common.ui.recommended() }}</cs-badge>
        }
        @if (default) {
          <cs-badge color="gray">{{ LL.common.ui.default() }}</cs-badge>
        }
        <ng-content select="cs-badge"></ng-content>
      </cs-label>
      <ng-content select="[item-right]"></ng-content>
    </div>
  }
  <ng-content select="cs-note"></ng-content>
  <ng-content select="cs-text-alert"></ng-content>
</div>

<!-- announced as a radio button that is selected or not, never as a plain button -->
<button cs-capture-cover (click)="handleButtonClick($event)" [disabled]="disabled" role="radio"
[attr.aria-checked]="checked ? 'true' : 'false'" [attr.aria-disabled]="disabled ? 'true' : null"></button>